module.exports = __webpack_public_path__ + "static/media/loading.a55d780f.gif";